var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-header center"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/small-logo.png"),"alt":"logo"}}),_c('div',{staticClass:"title"},[_c('div',[_vm._v("南京市市政设计研究院有限责任公司")]),_c('div',[_vm._v("安全建议与隐患举报")])])])
}]

export { render, staticRenderFns }